<img
  [src]="'/assets/img/icons/' + name + '.svg'"
  [height]="size"
  [width]="size"
  alt=""
  aria-hidden="true"
  (error)="onImageError($event)"
/>
